import actions from '../../actionTypes';

export default siteId => {
  return {
    type: actions.REMOVE_SITE,
    siteId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/sites/actions/removeSite.js